export default function InsightCard({ title = 'Scout Insight', body, linkText, onLinkClick }) {
  if (!body) return null;

  return (
    <div className="bg-surface-container-low border border-outline-variant/30 border-l-[3px] border-l-primary rounded-r-xl p-5">
      <h4 className="font-label font-semibold text-[11px] uppercase tracking-[0.12em] text-primary mb-2 flex items-center gap-2">
        <span className="material-symbols-outlined text-sm">format_quote</span>
        {title}
      </h4>
      <p className="text-[15px] italic text-on-surface leading-relaxed">{body}</p>
      {linkText && (
        <button
          onClick={onLinkClick}
          className="mt-4 flex min-h-[40px] items-center gap-1 font-label text-xs font-semibold uppercase tracking-[0.08em] text-primary hover:gap-2 transition-all"
        >
          {linkText}
          <span className="material-symbols-outlined text-xs">chevron_right</span>
        </button>
      )}
    </div>
  );
}
